import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Icon: FC<ISvG> = ({ fill = "#FFF" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19.25"
      height="22"
      viewBox="0 0 19.25 22"
    >
      <g id="png" transform="translate(-565 -294)">
        <g id="file-extension" transform="translate(565 294)">
          <path
            id="Контур_725"
            data-name="Контур 725"
            d="M20.7,0H32.387l6.192,6.168V20.625A1.375,1.375,0,0,1,37.2,22H20.7a1.375,1.375,0,0,1-1.375-1.375V1.375A1.375,1.375,0,0,1,20.7,0Z"
            transform="translate(-19.329)"
            fill="#69c17a"
          />
          <path
            id="Контур_726"
            data-name="Контур 726"
            d="M209.125,6.367h-4.793a1.375,1.375,0,0,1-1.375-1.375V.193Z"
            transform="translate(-189.894 -0.179)"
            fill="#2b6c37"
          />
        </g>
        <path
          id="Контур_813"
          data-name="Контур 813"
          d="M1.26-1.7v1.32H.322v-3.89H1.875a1.808,1.808,0,0,1,.79.164,1.238,1.238,0,0,1,.532.468,1.277,1.277,0,0,1,.188.688,1.126,1.126,0,0,1-.407.91A1.691,1.691,0,0,1,1.859-1.7Zm0-.724h.615a.58.58,0,0,0,.415-.136.506.506,0,0,0,.143-.385.626.626,0,0,0-.147-.436.52.52,0,0,0-.4-.166H1.26ZM7.188-.381H6.255L4.877-2.8V-.381H3.939v-3.89h.938L6.253-1.85V-4.271h.935Zm3.833-.481a1.508,1.508,0,0,1-.633.387,2.731,2.731,0,0,1-.914.147A1.629,1.629,0,0,1,8.253-.795a1.893,1.893,0,0,1-.489-1.3l0-.337a2.322,2.322,0,0,1,.2-1,1.508,1.508,0,0,1,.581-.66,1.644,1.644,0,0,1,.875-.231,1.723,1.723,0,0,1,1.129.333A1.41,1.41,0,0,1,11.018-3h-.9a.738.738,0,0,0-.208-.465.672.672,0,0,0-.454-.139.612.612,0,0,0-.545.3,1.6,1.6,0,0,0-.2.855v.235a1.564,1.564,0,0,0,.2.875.7.7,0,0,0,.627.293.788.788,0,0,0,.545-.163v-.6H9.431v-.644h1.59Z"
          transform="translate(569 309)"
          fill="#fff"
        />
      </g>
    </svg>
  );
};

export default memo(Icon);
